import { render, staticRenderFns } from "./MainFilters.vue?vue&type=template&id=24c59d8a"
import script from "./MainFilters.vue?vue&type=script&lang=js"
export * from "./MainFilters.vue?vue&type=script&lang=js"
import style0 from "./MainFilters.vue?vue&type=style&index=0&id=24c59d8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports